import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Mail } from "lucide-react";
import { BRAND, CONTACT_EMAIL } from "../lib/content";

const TikTokIcon = ({ size = 18 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

const XIcon = ({ size = 18 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/tattooedabroad/", Icon: Instagram, external: true },
  { label: "YouTube", href: "https://www.youtube.com/@tattooedabroad", Icon: Youtube, external: true },
  { label: "TikTok", href: "https://www.tiktok.com/@tattooedabroad", Icon: TikTokIcon, external: true },
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61592907290104", Icon: Facebook, external: true },
  { label: "X", href: "https://x.com/tattooedabroad", Icon: XIcon, external: true },
  { label: "Email", href: `mailto:${CONTACT_EMAIL}`, Icon: Mail, external: false },
];

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-white/10 bg-ink">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3 md:px-10">
      <div className="flex flex-col items-center text-center">
        <img src={BRAND.wordmark} alt="Tattooed Abroad" className="h-12 w-auto" />
        <p className="mt-5 font-body text-sm leading-relaxed text-white/50">A global documentary series.</p>
        <p className="mt-1 font-body text-sm leading-relaxed text-white/50">Journeys Written in Skin.</p>
      </div>

      <div>
        <h4 className="font-gothic text-sm uppercase tracking-[0.25em] text-flame">Explore</h4>
        <ul className="mt-5 space-y-3 font-body text-sm text-white/60">
          <li><Link to="/series" className="hover:text-flame">The Series</Link></li>
          <li><Link to="/videos" className="hover:text-flame" data-testid="footer-nav-videos">Videos</Link></li>
          <li><Link to="/socials" className="hover:text-flame">Socials</Link></li>
          <li><Link to="/support" className="hover:text-flame">Support / Kickstarter</Link></li>
          <li><Link to="/tattoo-times" className="hover:text-flame">Tattoo Times</Link></li>
        </ul>
      </div>

      <div className="flex flex-col items-center text-center">
        <h4 className="font-gothic text-sm uppercase tracking-[0.25em] text-flame">Connect</h4>
        <div className="mt-5 flex items-center justify-center gap-4">
          {SOCIALS.map(({ label, href, Icon, external }) => (
            <a
              key={label}
              href={href}
              {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
              aria-label={label}
              data-testid={`footer-social-${label.toLowerCase()}`}
              className="flex h-12 w-12 items-center justify-center border border-white/15 text-white/70 transition-colors hover:border-flame hover:text-flame"
            >
              <Icon size={18} />
            </a>
          ))}
        </div>
        <a href={`mailto:${CONTACT_EMAIL}`} className="mt-5 inline-block font-body text-sm text-white/50 hover:text-flame">{CONTACT_EMAIL}</a>
      </div>
    </div>

    <div className="border-t border-white/5 px-6 py-6 text-center md:px-10">
      <p className="font-body text-xs uppercase tracking-[0.2em] text-white/30">
        © {new Date().getFullYear()} Tattooed Abroad — Journeys Written in Skin
      </p>
    </div>
  </footer>
);
